import FirestoreProposalRepository from '@root/application/service/repository/proposal/FirestoreProposalRepository'

export const proposalRepoFireInstance = new FirestoreProposalRepository()

// export const usePropertyPaymentStatuses = hookRunner(propertyRepoInstance, 'paymentStatuses')
// export const usePropertyList = hookRunner(propertyRepoInstance, 'list', [])
